import styled from "styled-components";

export const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 50px;
`;

export const UploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-width: 100vw;
`;

export const Space = styled.div`
    margin-top: 10px;
`;
